import { memo } from 'react';

import { ComponentLink } from 'src/components/component-link';
import { RouterLinkProps } from 'src/router/components';
import { useLocation } from 'src/router/hooks';

export type WorkspaceLinkProps = Omit<RouterLinkProps, 'href'> & {
  href: string;
};

const BaseWorkspaceLink = (props: WorkspaceLinkProps) => {
  const { children, href, ...restProps } = props;

  const { pathname } = useLocation();
  const pathnameWithoutLeadingSlash = pathname.slice(1);
  const currentWorkspaceSlug = pathnameWithoutLeadingSlash.substring(
    0,
    pathnameWithoutLeadingSlash.indexOf('/')
  );

  const linkProps = {
    ...restProps,
    href,
  };

  /**
   * TODO remove target=_parent when navigation links are decoupled from window.__initial_state__
   *
   * target=_blank needs to be added onto workspace links that navigate to a workspace that differs
   * from the current workspace.
   *
   * Since h nav links are conditionally rendered based on workspace permissions, it is important that
   * window.__initial_state__ reflects the correct list of links to show. Since initial state is only
   * updated on page load, links to different workspaces need to trigger a page reload since initial
   * state will not be updated otherwise.
   */

  if (
    !href
      .replace(/https:\/\/.*\.org/, '')
      .startsWith(`/${currentWorkspaceSlug}/`) &&
    // Use a client-side navigation link if the href is a link to the account workspaces page
    !href.replace(/https:\/\/.*\.org/, '').startsWith(`/account/workspaces`)
  ) {
    linkProps.target = '_parent';
  }

  return <ComponentLink {...linkProps}>{children}</ComponentLink>;
};

export const WorkspaceLink = memo(BaseWorkspaceLink);
